import React, { Component } from 'react';
import PropTypes from 'prop-types';
import deepEqual from 'deep-equal';
import classnames from 'classnames';
import { LAX } from 'constants/Markets';
import DriverMarker from 'components/modules/shipper/DriverMarker';
import JobDetails from 'components/modules/shipments/tracking/JobDetails';
import SessionStore from 'stores/SessionStore';
import ShipmentWebAPIUtils from 'utils/ShipmentWebAPIUtils';

const DEFAULT_ZOOM = 10;
const SHIPMENT_TRACKING_MAP_ID = 'shipments-tracking-map';

function getMapOptions(center) {
  return {
    center: new google.maps.LatLng(...center),
    zoom: DEFAULT_ZOOM,
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_BOTTOM,
    },
    streetViewControlOptions: {
      position: google.maps.ControlPosition.RIGHT_BOTTOM,
    },
    streetViewControl: true,
    mapTypeControl: false,
  };
}
export default class DriverTrackingMap extends Component {
  static propTypes = {
    center: PropTypes.arrayOf(PropTypes.number).isRequired,
    className: PropTypes.object,
    markers: PropTypes.array,
    selectedShipment: PropTypes.object,
    onOpenShipment: PropTypes.func.isRequired,
    onMapClick: PropTypes.func.isRequired,
    onMarkerClick: PropTypes.func.isRequired,
    onCloseInfoWindow: PropTypes.func.isRequired,
    drivers: PropTypes.arrayOf(
      PropTypes.shape({
        _id: PropTypes.string.isRequired,
        first_name: PropTypes.string.isRequired,
        last_name: PropTypes.string.isRequired,
      }),
    ),
    activeDriver: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      fullName: PropTypes.string.isRequired,
      equipmentClassLabel: PropTypes.string.isRequired,
    }),
    setCurrentMarker: PropTypes.func,
  };

  static defaultProps = {
    className: {},
    selectedShipment: null,
    drivers: [],
    activeDriver: null,
    markers: [],
  };

  constructor(props) {
    super(props);
    this.setDefaultCenter();
  }

  componentDidMount() {
    let { center } = this.props;

    if (!center) {
      center = [...this.defaultCenter];
    }

    this.map = new google.maps.Map(
      document.getElementById(SHIPMENT_TRACKING_MAP_ID),
      getMapOptions(center),
    );
    this.mapListener = google.maps.event.addListener(
      this.map,
      'click',
      this.handleMapClick,
    );
  }

  componentDidUpdate(prevProps) {
    const centerChanged = !deepEqual(prevProps.center, this.props.center);

    if (centerChanged) {
      this.map.setOptions(getMapOptions(this.props.center));
    }

    const markersChanged = !deepEqual(prevProps.markers, this.props.markers);
    if (markersChanged) {
      this.setBounds();
    }
  }

  componentWillUnmount() {
    if (this.mapListener) {
      google.maps.event.removeListener(this.mapListener);
      this.mapListener = null;
    }
    this.map = null;
  }

  getDriverJobs = async (shipments) => {
    try {
      const jobs = await ShipmentWebAPIUtils.getDriverJobs(shipments);
      return jobs;
    } catch (e) {
      console.log('ERROR: ', e);
    }
  };

  setBounds() {
    const bounds = new google.maps.LatLngBounds();
    this.props.markers.forEach((m) => {
      bounds.extend(m.position);
    });
    this.map.fitBounds(bounds);
    if (this.mapListener) {
      google.maps.event.removeListener(this.mapListener);
    }
    this.mapListener = google.maps.event.addListener(
      this.map,
      'click',
      this.handleMapClick,
    );
  }

  setDefaultCenter() {
    const { origin } = SessionStore.getUser();

    if (origin) {
      this.defaultCenter = origin.coords.slice().reverse();
    } else {
      this.defaultCenter = LAX.center;
    }
  }

  handleMapClick = () => this.props.onMapClick();
  renderMarkers() {
    const { map } = this;
    return this.props.markers.map((marker) => (
      <DriverMarker
        id={marker.id}
        position={marker.position}
        key={marker.id}
        isActive={marker.isActive}
        listOpen={marker.listOpen}
        map={map}
        driver={marker.driver}
        phone={marker.phone}
        jobs={marker.jobs || []}
        hasActiveJobs={marker.hasActiveJobs}
        onOpenShipment={this.props.onOpenShipment}
        onCloseInfoWindow={this.props.onCloseInfoWindow}
        onMarkerClick={this.props.onMarkerClick}
        setCurrentMarker={this.props.setCurrentMarker}
      />
    ));
  }

  renderJobDetails() {
    if (this.props.selectedShipment) {
      return (
        <JobDetails
          job={this.props.selectedShipment}
          drivers={this.props.drivers}
          activeDriver={this.props.activeDriver}
        />
      );
    }
    return null;
  }

  render() {
    const className = classnames({
      ...this.props.className,
      'shipments-tracking': true,
    });

    return (
      <div className={className}>
        <div id={SHIPMENT_TRACKING_MAP_ID}>{this.renderMarkers()}</div>
        {this.renderJobDetails()}
      </div>
    );
  }
}
